import React, { useEffect } from "react";
import { handleSearch } from "../redux/slices/generalSlice";
import { useDispatch } from "react-redux";

const Modal = ({ children, closeModal, modalRef, showModal, modalTitle, paddingZero }) => {

  const dispatch = useDispatch()
  useEffect(() => {
    const handleCloseModal = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeModal();
        dispatch(handleSearch(""));
      }
    };

    document.addEventListener("mousedown", handleCloseModal);

    return () => {
      document.removeEventListener("mousedown", handleCloseModal);
    };
  }, [showModal]);

  return (
    <div className={`modal custom-popup-overlay ${showModal ? "show" : ""}`}>
      <div className="modal-content custom-popup-add" ref={modalRef} style={paddingZero}>
        <span className="close" onClick={closeModal}>
          &times;
        </span>
        {modalTitle && (
          <>
            <h2>{modalTitle}</h2>
            <div className="after-line-tittle"></div>
          </>
        )}
        <div>{children}</div>
      </div>
    </div>
  );
};

export default Modal;
